import { FilterOptModel } from "../hooks/featureFlagsProvider";

export const persistFilterOption = (key: string, value: any, filterOptions: FilterOptModel[]) => {
  const filterOption = filterOptions.find((option) => option.key === key);
  if (filterOption && filterOption.storage) {
    if (value === null || value === undefined) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value);
    }
  }
};